import { render } from "./EmailWidget.vue?vue&type=template&id=673287a8&scoped=true"
import script from "./EmailWidget.vue?vue&type=script&lang=ts"
export * from "./EmailWidget.vue?vue&type=script&lang=ts"

import "./EmailWidget.vue?vue&type=style&index=0&id=673287a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-673287a8"

export default script